<template>
  <b-card v-if="displayCharts" border-variant="primary" header-border-variant="primary"
          header-bg-variant="light"
          header-text-variant="dark" header-class="text-center">
    <VarsChart class="border" id="bp-Chart" ref="bp" title="Показатели" :series="charts.bp"/>
    <VarsChart class="border" id="age-Chart" ref="age" title="Возраст" :series="charts.age"/>
    <VarsChart class="border" id="muscleLevel-Chart" ref="muscleLevel" title="Системы энергообеспечения"
               :series="charts.muscleLevel"/>
    <VarsChart class="border" id="iap-Chart" ref="iap" title="Индивидуальный лактатный порог" :series="charts.iap"/>
    <VarsChart class="border" id="sfp-Chart" ref="sfp" title="Уровень функциональной подготовленности"
               :series="charts.sfp"/>
    <VarsChart class="border" id="bmr-Chart" ref="bmr" title="Basal Metabolic Rate" :series="charts.bmr"/>
  </b-card>
</template>

<script>
import VarsChart from "./charts/VarsChart";

export default {
  components: {
    VarsChart,
  },
  props: {},
  data() {
    return {
      charts: {
        bp: [
          {
            id: 'bpsys',
            name: 'АДс',
            dimension: 'мм рт. ст.',
            data: [],
            min: 0,
            max: 220,
          },
          {
            id: 'bpdia',
            name: 'АДд',
            dimension: 'мм рт. ст.',
            data: [],
            min: 0,
            max: 220,
          },
          {
            id: 'hr',
            name: 'Пульс',
            dimension: 'уд / мин',
            data: [],
            min: 0,
            max: 220,
          },
        ],
        age: [
          {
            id: 'age',
            name: 'Возраст',
            dimension: 'лет',
            data: [],
            min: 10,
            max: 100,
          },
          {
            id: 'sportAge',
            name: 'Спорт. в-т',
            dimension: 'лет',
            data: [],
            min: 10,
            max: 100,
          },
          {
            id: 'realBiologicalAge',
            name: 'Real Biological Age',
            dimension: 'лет',
            data: [],
            min: 10,
            max: 100,
          },
        ],
        muscleLevel: [
          {
            id: 'sopMuscleLevel',
            name: 'Креатинфосфатная ёмкость',
            dimension: '%',
            data: [],
            min: 0,
            max: 130,
            converter: function (x) {
              return Math.abs(x);
            },
          },
          {
            id: 'ksdMuscleLevel',
            name: 'Анаэробная мощность',
            dimension: '%',
            data: [],
            min: 0,
            max: 130,
            converter: function (x) {
              return Math.abs(x);
            },
          },
          {
            id: 'kyadMuscleLevel',
            name: 'Аэробная мощность',
            dimension: '%',
            data: [],
            min: 0,
            max: 130,
            converter: function (x) {
              return Math.abs(x);
            },
          },
          {
            id: 'odv',
            name: 'Эффективность восстановления',
            dimension: '%',
            data: [],
            min: 0,
            max: 130,
          },
        ],
        iap: [
          {
            id: 'hrStart',
            name: 'Пульс старт',
            dimension: 'уд/мин',
            data: [],
            min: 0,
            max: 220,
          },
          {
            id: 'hrEnd',
            name: 'Пульс финиш',
            dimension: 'уд/мин',
            data: [],
            min: 0,
            max: 220,
          },
          {
            id: 'hrMin2',
            name: 'Пульс восст.',
            dimension: 'уд/мин',
            data: [],
            min: 0,
            max: 220,
          },
          {
            id: 'iap',
            name: 'Индивидуальный лактатный порог',
            dimension: 'уд/мин',
            data: [],
            min: 0,
            max: 220,
          }
        ],
        sfp: [
          {
            id: 'sfp',
            name: 'Уровень функциональной подготовленности',
            dimension: 'единиц',
            data: [],
            min: 0,
            max: 6,
          },
        ],
        bmr: [
          {
            id: 'bmr',
            name: 'Basal Metabolic Rate',
            dimension: 'ккал/день',
            data: [],
            min: 500,
            max: 6000,
          }
        ],
      },
      displayCharts: false,
    }
  },
  methods: {
    error() {
      this.displayCharts = false;
    },
    addDataToCharts(data) {
      const vm = this;
      for (let chartsKey in vm.charts) {
        if (vm.charts.hasOwnProperty(chartsKey)) {
          vm.charts[chartsKey].forEach(series => {
            const addNull = function (time) {
              series.data.push([time, null]);
            };
            series.data.splice(0);

            data.forEach((d, index) => {
              let data = d[series.id];
              if (typeof (data) != 'undefined') {
                let v = series.converter ? series.converter(data) : data;
                series.data.push([index, v]);
              }
              this.displayCharts = true;
            });
            if (data.length > 1) {
              addNull(data.length);
            }
          });
          if (vm.$refs[chartsKey]) {
            vm.$refs[chartsKey].updateSeries(vm.charts[chartsKey]);
          }
        }
      }
    }
  }
}
</script>